import DelayActionButton from './delay_action_button'

const DelayDeleteButton = ({
  onDelete,
  delayTimeMs,
  className,
  displayText,
  disabled,
}) => {
  const deleteText = displayText != null ? displayText : 'Delete'
  return (
    <DelayActionButton
      onAction={onDelete}
      delayTimeMs={delayTimeMs}
      className={className}
      displayText={deleteText}
      confirmDisplayText="Confirm deletion"
      disabled={disabled}
    />
  )
}

export default DelayDeleteButton
